module.exports = __webpack_public_path__ + "static/turquia-010.thumb-ce1b4eaff5d8cb746853c5764cd09dfd.jpg";